module.exports = __webpack_public_path__ + "media/images/payment/logo_mini-91f29976de7aba33b981f6685518d3a5.gif";